import Store from '@ember-data/store';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ContactsCache, {
  type ContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';
import Settings from 'donor-elf-web/services/settings';

interface ComponentArgs {
  onClose: (saved: boolean) => void;
}

export default class ContactDetailsPropertiesCustomPropertyReorderModalComponent extends Component<ComponentArgs> {
  [key: string]: any;
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    let {
      sortedCustomPropertiesForDetailPage,
      customPropertyUserSettingForDetailPage,
    } = this.contactsCache;
    this.alwaysShowPropertyInfos = sortedCustomPropertiesForDetailPage.filter(
      (p) => customPropertyUserSettingForDetailPage[p.l]?.show === true,
    );
    this.hideIfBlankPropertyInfos = sortedCustomPropertiesForDetailPage.filter(
      (p) =>
        customPropertyUserSettingForDetailPage[p.l]?.show !== true &&
        customPropertyUserSettingForDetailPage[p.l]?.hide !== true,
    );
    this.alwaysHidePropertyInfos = sortedCustomPropertiesForDetailPage.filter(
      (p) => customPropertyUserSettingForDetailPage[p.l]?.hide === true,
    );
  }

  @service declare contactsCache: ContactsCache;
  @service declare settings: Settings;
  @service declare store: Store;

  @tracked alwaysShowPropertyInfos: ContactCustomPropertyInfo[] = [];
  @tracked hideIfBlankPropertyInfos: ContactCustomPropertyInfo[] = [];
  @tracked alwaysHidePropertyInfos: ContactCustomPropertyInfo[] = [];

  @tracked saving = false;
  @tracked saveError?: any;

  @action
  moveDown(listPropertyName: string, index: number) {
    let list = this[listPropertyName]! as ContactCustomPropertyInfo[];
    if (index < list.length - 1) {
      let temp = list[index];
      list[index] = list[index + 1];
      list[index + 1] = temp;
    }
    this[listPropertyName] = list;
  }

  @action
  moveUp(listPropertyName: string, index: number) {
    let list = this[listPropertyName]! as ContactCustomPropertyInfo[];
    if (index > 0) {
      let temp = list[index];
      list[index] = list[index - 1];
      list[index - 1] = temp;
    }
    this[listPropertyName] = list;
  }

  @action
  moveToAlwaysShow(propertyInfo: ContactCustomPropertyInfo) {
    this.alwaysShowPropertyInfos = [
      ...this.alwaysShowPropertyInfos,
      propertyInfo,
    ];
    this.hideIfBlankPropertyInfos = this.hideIfBlankPropertyInfos.filter(
      (p) => p.l !== propertyInfo.l,
    );
    this.alwaysHidePropertyInfos = this.alwaysHidePropertyInfos.filter(
      (p) => p.l !== propertyInfo.l,
    );
  }

  @action
  moveToHideIfBlank(propertyInfo: ContactCustomPropertyInfo) {
    this.hideIfBlankPropertyInfos = [
      ...this.hideIfBlankPropertyInfos,
      propertyInfo,
    ];
    this.alwaysShowPropertyInfos = this.alwaysShowPropertyInfos.filter(
      (p) => p.l !== propertyInfo.l,
    );
    this.alwaysHidePropertyInfos = this.alwaysHidePropertyInfos.filter(
      (p) => p.l !== propertyInfo.l,
    );
  }

  @action
  moveToAlwaysHide(propertyInfo: ContactCustomPropertyInfo) {
    this.alwaysHidePropertyInfos = [
      ...this.alwaysHidePropertyInfos,
      propertyInfo,
    ];
    this.alwaysShowPropertyInfos = this.alwaysShowPropertyInfos.filter(
      (p) => p.l !== propertyInfo.l,
    );
    this.hideIfBlankPropertyInfos = this.hideIfBlankPropertyInfos.filter(
      (p) => p.l !== propertyInfo.l,
    );
  }

  @action
  async save() {
    this.saving = true;
    let { contactCustomPropertyUserSetting } = this.settings;
    if (contactCustomPropertyUserSetting == null) {
      contactCustomPropertyUserSetting = this.store.createRecord(
        'contact-custom-property-user-setting',
        {
          detailPage: [],
        },
      );
    }

    contactCustomPropertyUserSetting!.detailPage = [
      ...this.alwaysShowPropertyInfos.map((p) => ({ l: p.l, show: true })),
      ...this.hideIfBlankPropertyInfos.map((p) => ({ l: p.l })),
      ...this.alwaysHidePropertyInfos.map((p) => ({ l: p.l, hide: true })),
    ];

    try {
      this.settings.contactCustomPropertyUserSetting =
        contactCustomPropertyUserSetting;
      await contactCustomPropertyUserSetting.save();
      this.args.onClose(true);
    } catch (error: any) {
      this.saveError = error;
    }
  }
}
